import { Option } from 'components/shared/ControlledFields/ControlledSelect';

import { KeysMatchingType } from './typeModifiers';

export const toOptions = <R extends Record<string, any>>(
  responseArray: R[],
  value: KeysMatchingType<R, Option['value']>,
  label: KeysMatchingType<R, Option['label']>
) =>
  responseArray.map((response) => ({
    value: response[value],
    label: response[label]
  }));

export const toOptionsCurry =
  <R extends Record<string, any>>(
    value: KeysMatchingType<R, Option['value']>,
    label: KeysMatchingType<R, Option['label']>
  ) =>
  (responseArray: R[]): Option[] =>
    toOptions(responseArray, value, label);
